/**
 * Favotrip Exclusive op favotrip.de: de aan/uit-regel (brief A1, publieke
 * Duitse pagina's; brief A3, ingelogde leden met ledenprijs en boeken).
 *
 * UIT (standaard): favotrip.de gedraagt zich precies als op main. Een
 * Exclusive-adres op .de krijgt de 308 van main (naar /ing met ING_DE_LIVE
 * aan, anders naar https://www.favotrip.nl/exclusive).
 *
 * AAN: /exclusive en /exclusive/<naam> renderen op .de zelf; een ingelogd lid
 * ziet daar de Duitse hub en hotelpagina met zijn ledenprijs en boekt via de
 * Duitse boekstraat (src/lib/luxe/exclusive-de-leden.js).
 *
 * Eén constante, zonder imports, zodat middleware, browser en routes dezelfde
 * regel lezen. Aanzetten is een aparte PR van één regel plus test (zelfde
 * patroon als src/lib/luxe/ing-de-flags.js), met in de beschrijving het bewijs
 * dat aanmelden en inloggen op .de (backend A2) live staan.
 *
 * Add/add met brief A1 (tak feat/exclusive-de-publiek): wie als tweede landt,
 * neemt de constante en de functie van A1 over; de naam is dezelfde.
 */
export const LUXE_DE_PUBLIEK_LIVE = false;

/** true als Favotrip Exclusive op favotrip.de aan staat. */
export function luxeDePubliekLive() {
  return LUXE_DE_PUBLIEK_LIVE === true;
}
